export default __webpack_public_path__ + "static/media/qrcode-invite.4ea0b1a9.svg";